import { render, staticRenderFns } from "./ico-btn.vue?vue&type=template&id=845dbddc&scoped=true&"
import script from "./ico-btn.vue?vue&type=script&lang=ts&"
export * from "./ico-btn.vue?vue&type=script&lang=ts&"
import style0 from "./ico-btn.vue?vue&type=style&index=0&id=845dbddc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "845dbddc",
  null
  
)

export default component.exports